import { type MutableRefObject } from 'react';

export const mutationObserver = ({
  nodeRef,
  measure,
  handleLoadImages,
}: {
  handleLoadImages: () => void;
  measure: () => void;
  nodeRef: MutableRefObject<HTMLElement | null>;
}) => {
  if (nodeRef.current) {
    measure?.();

    // Re-get all images each time mutation observer is exec
    handleLoadImages();
  }
};
